/*
 * @Description:患者性别
 * @Date: 2024-01-09 14:33:01
 */
import { nextTick, ref, computed } from 'vue';

export const sequence = computed(() => {
  return ['A', 'B', 'C', 'D', 'E', 'F'];
});

export const selfAdaption = async (TaskRef, ContentRef, scale) => {
  await nextTick(() => {
    const parent = TaskRef.value.parentNode as HTMLDivElement;
    const parentWidth = parent.offsetWidth;
    const parentHeight = parent.offsetHeight;
    const contentWidth = ContentRef.value.offsetWidth;
    const constHeight = ContentRef.value.offsetHeight;
    scale.value = Math.min(
      1,
      parentWidth / contentWidth,
      parentHeight / constHeight == 0 ? 1 : parentHeight / constHeight
    );
  });
};
export const pcModulePatientSex1 = (dom: HTMLDivElement) => {
  const circleItmeDom = dom.querySelectorAll(
    '#circle'
  ) as NodeListOf<HTMLDivElement>;
  const tipsLine = dom.querySelectorAll(
    '#tips-line'
  ) as NodeListOf<HTMLDivElement>;
  const tipsText = dom.querySelectorAll(
    '#tips-text'
  ) as NodeListOf<HTMLDivElement>;
  const nubSpanDom = dom.querySelectorAll(
    '#circle span'
  ) as NodeListOf<HTMLDivElement>;
  if (circleItmeDom.length == 1) {
    circleItmeDom[0].style.clipPath = 'none';
    circleItmeDom[0].style.height = '100%';
    circleItmeDom[0].style.width = '100%';
  }
  circleItmeDom.forEach((item, index) => {
    if (circleItmeDom.length == 2) {
      item.style.width = '10000%';
      if (index + 1 == 2) {
        item.style.transform = 'rotate(180deg)';
        tipsLine[index].style.transform = `rotate(${index * 180}deg)`;
        nubSpanDom[index].style.transform = ' rotate(180deg)';
        tipsText[index].style.top = '372px';
        tipsText[index].style.left = '50%';
        tipsText[index].style.transform = 'translate(-50%)';
        tipsLine[index].style.width = '153px';
      }
    } else if (circleItmeDom.length == 3) {
      item.style.width = '184%';
      item.style.transform = `rotate(${index * 120}deg)`;
      tipsLine[index].style.transform = `rotate(${index * 120}deg)`;
      if (index + 1 == 2) {
        tipsText[index].style.top = '243px';
        nubSpanDom[index].style.transform = ' rotate(-120deg)';
      }
      if (index + 1 == 3) {
        nubSpanDom[index].style.transform = ' rotate(120deg)';
        tipsText[index].style.bottom = '40px';
        tipsText[index].style.left = '0';
        tipsText[index].style.top = '243px';
        tipsLine[1].style.width = '166px';
      }
    } else if (circleItmeDom.length == 4) {
      item.style.width = '106%';
      item.style.transform = `rotate(${index * 90}deg)`;
      tipsLine[index].style.transform = `rotate(${index * 90}deg)`;
      if (index + 1 == 2) {
        tipsLine[index].style.width = '143px';
        tipsText[index].style.top = '160px';
        nubSpanDom[index].style.transform = ' rotate(-90deg)';
      }
      if (index + 1 == 3) {
        nubSpanDom[index].style.transform = ' rotate(-180deg)';
        tipsText[index].style.bottom = '40px';
        tipsText[index].style.right = '50%';
        tipsLine[index].style.width = '152px';
        tipsText[index].style.top = '372px';
        tipsText[index].style.transform = 'translate(50%)';
      }
      if (index + 1 == 4) {
        tipsLine[index].style.width = '143px';
        tipsText[index].style.top = '160px';
        tipsText[index].style.left = '0px';
        nubSpanDom[index].style.transform = ' rotate(90deg)';
        tipsText[index].style.transform = 'none';
      }
    } else if (circleItmeDom.length == 5) {
      item.style.width = '77%';
      item.style.transform = `rotate(${index * 72}deg)`;
      tipsLine[index].style.transform = `rotate(${index * 72}deg)`;
      if (index + 1 == 2) {
        tipsLine[index].style.width = '150px';
        nubSpanDom[index].style.transform = ' rotate(-70deg)';
      }
      if (index + 1 == 3) {
        nubSpanDom[index].style.transform = ' rotate(-140deg)';
        tipsText[index].style.bottom = '40px';
        tipsText[index].style.right = '37px';
        tipsLine[index].style.width = '180px';
        tipsText[index].style.top = 'none';
        tipsText[index].style.top = '333px';
      }
      if (index + 1 == 4) {
        nubSpanDom[index].style.transform = ' rotate(150deg)';
        tipsText[index].style.bottom = '40px';
        tipsText[index].style.left = '37px';
        tipsLine[index].style.width = '180px';
        tipsText[index].style.transform = 'none';
      }
      if (index + 1 == 5) {
        nubSpanDom[index].style.transform = ' rotate(80deg)';
        tipsText[index].style.top = '97px';
        tipsLine[index].style.width = '150px';
        tipsLine[2].style.width = '182px';
      }
    }
  });
};

export const pcModulePatientSex5 = (
  RefIcon,
  RefTextItem,
  splitCount,
  svgHTML
) => {
  //图标盒子的中间点Y
  const iconContentY = ref<number>(
    RefIcon.value.offsetTop + RefIcon.value.offsetHeight / 2
  );
  const lines = ref<string[]>([]);
  const radian = ref<number>(50);
  //起点
  const startDot = ref<number[]>([]);
  //结束点
  const endDot = ref<number[]>([]);
  //曲线点
  const curveDot = ref<number[]>([]);
  const lineWidth = ref<number>(3);
  const rightIndex = ref<number>(0);
  const offest1Y = ref<number>(8);
  const offest2Y = ref<number>(8);
  RefTextItem.value.forEach((itemDom, domIndex) => {
    if (domIndex < splitCount.value) {
      //左边
      if ([2, 1].includes(RefTextItem.value.length)) {
        offest1Y.value = 1;
        offest2Y.value = 0;
      }
      if ([3, 4].includes(RefTextItem.value.length)) {
        offest1Y.value = 8;
        offest2Y.value = 3;
      }

      startDot.value = [
        RefIcon.value.offsetLeft,
        iconContentY.value + domIndex * offest1Y.value - offest2Y.value
      ];
      curveDot.value = [
        RefIcon.value.offsetLeft - radian.value,
        iconContentY.value + domIndex * offest1Y.value - offest2Y.value
      ];

      endDot.value = [
        itemDom.offsetLeft + itemDom.offsetWidth,
        itemDom.offsetTop + itemDom.offsetHeight / 2
      ];
    } else {
      //右边
      if ([2].includes(RefTextItem.value.length)) {
        offest1Y.value = 1;
        offest2Y.value = 0;
      }
      if ([3, 4, 5].includes(RefTextItem.value.length)) {
        offest1Y.value = 8;
        offest2Y.value = RefTextItem.value.length == 3 ? 0 : 3;
      }
      startDot.value = [
        RefIcon.value.offsetLeft + RefIcon.value.offsetWidth,
        iconContentY.value + rightIndex.value * offest1Y.value - offest2Y.value
      ];
      curveDot.value = [
        RefIcon.value.offsetLeft + RefIcon.value.offsetWidth + radian.value,
        iconContentY.value + rightIndex.value * offest1Y.value - offest2Y.value
      ];
      endDot.value = [
        itemDom.offsetLeft,
        itemDom.offsetTop + itemDom.offsetHeight / 2
      ];
      rightIndex.value += 1;
    }
    lines.value.push(
      `<path d="M${startDot.value[0]} ${startDot.value[1]}    Q ${
        curveDot.value[0]
      } ${curveDot.value[1]} ${endDot.value[0]} ${
        endDot.value[1]
      }"  fill="none" stroke="var(--theme-color-${domIndex + 1},#000
       
      )" stroke-width="${lineWidth.value}"></path>`
    );
  });

  svgHTML.value = `
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
  ${lines.value.join('')}
  </svg>`;
};

export const pcModulePatientSex6 = (dom: HTMLDivElement) => {
  const pintsDom = dom.querySelectorAll('#pints') as NodeListOf<HTMLDivElement>;
  const linesDom = dom.querySelectorAll('#lines') as NodeListOf<HTMLDivElement>;
  const textsDom = dom.querySelectorAll('#texts') as NodeListOf<HTMLDivElement>;
  linesDom.forEach((item, index) => {
    if (index + 1 > 3 && pintsDom.length == 6) {
      item.style.transform = 'rotate(180deg)';
    }
    if ([1, 5, 4].includes(index + 1) && pintsDom.length == 5) {
      item.style.transform = 'rotate(180deg)';
    }
    if ([1, 4].includes(index + 1) && pintsDom.length == 4) {
      item.style.transform = 'rotate(180deg)';
    }
    if ([1].includes(index + 1) && pintsDom.length == 3) {
      item.style.transform = 'rotate(180deg)';
    }
    if ([2].includes(index + 1) && pintsDom.length == 2) {
      item.style.transform = 'rotate(180deg)';
    }
  });
  if (pintsDom.length == 6) {
    textsDom[0].style.bottom = '60px';
    pintsDom[0].style.top = '120px';
    textsDom[1].style.bottom = '3px';
    textsDom[1].style.left = '280px';
    pintsDom[1].style.top = '163px';
    pintsDom[1].style.left = '129px';
    textsDom[2].style.bottom = '50px';
    textsDom[2].style.left = '570px';
    pintsDom[2].style.top = '133px';
    pintsDom[2].style.left = '410px';
    textsDom[3].style.top = '50px';
    textsDom[3].style.left = '700px';
    pintsDom[3].style.top = '43px';
    pintsDom[3].style.left = '539px';
    textsDom[4].style.left = '420px';
    pintsDom[4].style.top = '15px';
    pintsDom[4].style.left = '402px';
    textsDom[5].style.top = '48px';
    textsDom[5].style.left = '140px';
    pintsDom[5].style.top = '57px';
    pintsDom[5].style.left = '102px';
  }
  if (pintsDom.length == 5) {
    textsDom[0].style.left = '50px';
    textsDom[0].style.top = '80px';
    pintsDom[0].style.top = '88px';
    pintsDom[0].style.left = '30px';

    textsDom[1].style.left = '150px';
    textsDom[1].style.bottom = '10px';
    pintsDom[1].style.top = '152px';
    pintsDom[1].style.left = '43px';

    textsDom[2].style.left = '600px';
    textsDom[2].style.bottom = '60px';
    pintsDom[2].style.top = '122px';
    pintsDom[2].style.left = '443px';

    textsDom[3].style.left = '700px';
    textsDom[3].style.top = '50px';
    pintsDom[3].style.top = '47px';
    pintsDom[3].style.left = '543px';

    textsDom[4].style.left = '480px';
    pintsDom[4].style.top = '18px';
    pintsDom[4].style.left = '443px';
  }
  if (pintsDom.length == 4) {
    textsDom[0].style.left = '50px';
    textsDom[0].style.top = '80px';
    pintsDom[0].style.top = '88px';
    pintsDom[0].style.left = '30px';

    textsDom[1].style.left = '150px';
    textsDom[1].style.bottom = '10px';
    pintsDom[1].style.top = '153px';
    pintsDom[1].style.left = '43px';

    textsDom[2].style.left = '600px';
    textsDom[2].style.bottom = '60px';
    pintsDom[2].style.top = '124px';
    pintsDom[2].style.left = '443px';

    textsDom[3].style.left = '480px';
    pintsDom[3].style.top = '20px';
    pintsDom[3].style.left = '443px';
  }
  if (pintsDom.length == 3) {
    textsDom[0].style.left = '50px';
    textsDom[0].style.top = '80px';
    pintsDom[0].style.top = '87px';
    pintsDom[0].style.left = '32px';

    textsDom[1].style.left = '150px';
    textsDom[1].style.bottom = '10px';
    pintsDom[1].style.top = '153px';
    pintsDom[1].style.left = '43px';

    textsDom[2].style.left = '600px';
    textsDom[2].style.bottom = '60px';
    pintsDom[2].style.top = '124px';
    pintsDom[2].style.left = '443px';
  }
  if (pintsDom.length == 2) {
    textsDom[0].style.bottom = '60px';
    pintsDom[0].style.top = '130px';
    textsDom[1].style.left = '20px';

    textsDom[1].style.top = '50px';
    textsDom[1].style.left = '700px';
    pintsDom[1].style.top = '43px';
    pintsDom[1].style.left = '539px';
  }
};

export const pcModulePatientSex7 = (
  dom: HTMLDivElement,
  dataArrCeil: number
) => {
  const roundItemsDom = dom.querySelectorAll(
    '#roundItems'
  ) as NodeListOf<HTMLDivElement>;
  const arrowItemsDom = dom.querySelectorAll(
    '#arrowItems'
  ) as NodeListOf<HTMLDivElement>;
  const textItemsDom = dom.querySelectorAll(
    '#textItems'
  ) as NodeListOf<HTMLDivElement>;
  const linesDom = dom.querySelectorAll(
    '#lines-sex-7'
  ) as NodeListOf<HTMLDivElement>;
  const textRItemsDom = dom.querySelectorAll(
    '#text-r'
  ) as NodeListOf<HTMLDivElement>;
  const contents = dom.querySelector('#warp-round');
  const r1 = contents.clientWidth / 2;
  const count = roundItemsDom.length;
  const pieceDeg = 360 / count;
  for (let i = 0; i < count; i++) {
    let t = i * pieceDeg;
    t = (Math.PI / 180) * t;
    const x1 = Math.sin(t) * r1;
    const y1 = -Math.cos(t) * r1;
    linesDom[i].style.transform = `rotate(${pieceDeg * i}deg)`;
    roundItemsDom[i].style.transform = `translate(${x1}px,${y1}px) `;
    arrowItemsDom[i].style.transform = `rotate(${pieceDeg * i + 6}deg)`;
    textItemsDom[i].style.transform = `rotate(${pieceDeg * i}deg)`;
    textRItemsDom[i].style.transform = `rotate(-${pieceDeg * i}deg)`;
    textRItemsDom[0].style.top = '-145px';
    textRItemsDom[0].style.left = '21px';

    if (textItemsDom.length == 6) {
      // 两边提示靠拢
      if ([1, 4].includes(i)) {
        textItemsDom[i].style.transform = `rotate(${pieceDeg * i + 12}deg)`;
        textRItemsDom[i].style.transform = `rotate(-${pieceDeg * i + 12}deg)`;
      }
      if ([2, 5].includes(i)) {
        textItemsDom[i].style.transform = `rotate(${pieceDeg * i - 12}deg)`;
        textRItemsDom[i].style.transform = `rotate(-${pieceDeg * i - 12}deg)`;
      }
    }
    if (textItemsDom.length == 5) {
      // 两边提示靠拢
      if ([3].includes(i)) {
        textItemsDom[3].style.transform = `rotate(${pieceDeg * i + 15}deg)`;
        textRItemsDom[3].style.transform = `rotate(-${pieceDeg * i + 15}deg)`;
      }
      if ([2].includes(i)) {
        textItemsDom[2].style.transform = `rotate(${pieceDeg * i - 15}deg)`;
        textRItemsDom[2].style.transform = `rotate(-${pieceDeg * i - 15}deg)`;
      }
    }
    if ([6, 4, 2].includes(textItemsDom.length)) {
      //调整间距
      textRItemsDom[dataArrCeil].style.top = '-145px';
      textRItemsDom[dataArrCeil].style.left = '21px';
    }
  }
};

type ItemData = {
  label: string;
  value: string;
};
type TextItem = {
  tipData: any[][];
  projectName: ItemData[];
};

//数据组装
export const useDataAssembly = (
  tableHeaderList: Array<{ label: Array<string>; prop: string }>,
  tableDataList: Array<{ [key: string]: Array<string> }>,
  slicNumber = false
) => {
  const tipItme = () => {
    const optionArr: Array<ItemData> = [];
    const tipItmeArr: Array<Array<ItemData>> = [];
    tableDataList.forEach(DataItem => {
      const item: Array<ItemData> = [];
      tableHeaderList.forEach(HeadeItem => {
        const obj = {} as ItemData;
        if (!['item', 'numRange'].includes(HeadeItem.prop)) {
          obj[Object.keys(HeadeItem)[Object.keys(HeadeItem).indexOf('label')]] =
            HeadeItem['label'][0];
          obj['value'] = DataItem[HeadeItem.prop][0];
          item.push(obj);
        } else {
          obj[Object.keys(HeadeItem)[Object.keys(HeadeItem).indexOf('label')]] =
            HeadeItem['label'][0];
          obj['value'] = DataItem[HeadeItem.prop][0];
          optionArr.push(obj);
        }
      });
      tipItmeArr.push(item);
    });
    return { tipData: tipItmeArr, projectName: optionArr };
  };
  return computed(() => {
    const textItem: TextItem = tipItme();
    if (slicNumber == true) {
      textItem.tipData.forEach((item, index) => {
        item.push(index + 1);
      });
      const splitNumber = computed(() => {
        return Math.ceil(textItem.tipData.length / 2);
      });
      textItem.tipData = [...textItem.tipData].reduce(
        (per, cur, index) => {
          if (index < splitNumber.value) {
            per[0].push(cur);
          } else {
            per[1].push(cur);
          }
          return per;
        },
        [[], []]
      );
    }

    return textItem;
  });
};
